import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import BoardingSlaService from '_services/boarding-sla-service';

export const fetchBoardingSla = createAsyncThunk(
  'boardingSla/fetch',
  async (params, { signal }) => {
    return await BoardingSlaService.getBoardingSla(params, signal);
  }
);

export const patchBoardingOverride = createAsyncThunk(
  'boardingSla/patchOverride',
  async ({ bookingId, kpiKey, pass, passReason, ignore }) => {
    let overrideValue;
    if (ignore) {
      overrideValue = { ignore: true, pass: null, passReason, reason: passReason };
    } else {
      overrideValue = { ignore: false, pass, passReason, reason: passReason };
    }
    const patch = kpiKey
      ? { boardingSlaOverride: { [kpiKey]: overrideValue } }
      : { boardingSlaOverride: overrideValue };
    await BoardingSlaService.patchBooking(bookingId, patch);
    return { bookingId };
  }
);

const initialState = {
  data: null,
  status: 'idle',
  error: null,
  patchStatus: 'idle',
};

const boardingSlaSlice = createSlice({
  name: 'boardingSla',
  initialState,
  reducers: {
    resetBoardingSla: (state) => {
      state.data = null;
      state.status = 'idle';
      state.error = null;
    },
    resetPatchBoardingOverrideStatus: (state) => {
      state.patchStatus = 'idle';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBoardingSla.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchBoardingSla.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchBoardingSla.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(patchBoardingOverride.pending, (state) => {
        state.patchStatus = 'loading';
      })
      .addCase(patchBoardingOverride.fulfilled, (state) => {
        state.patchStatus = 'succeeded';
      })
      .addCase(patchBoardingOverride.rejected, (state) => {
        state.patchStatus = 'failed';
      });
  },
});

export const selectBoardingSlaData = (state) => state.boardingSla.data;
export const selectBoardingSlaStatus = (state) => state.boardingSla.status;
export const selectBoardingSlaError = (state) => state.boardingSla.error;
export const selectPatchBoardingOverrideStatus = (state) => state.boardingSla.patchStatus;

export const { resetBoardingSla, resetPatchBoardingOverrideStatus } = boardingSlaSlice.actions;

export default boardingSlaSlice.reducer;
